/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";

export const FlagsUserManagement = {
  email_validation: new Rox.RoxString(""),
};

export function initFlagsUserManagement() {
  // register flags with namespaces for better grouping
  Rox.register("userManagement", FlagsUserManagement);
}
